import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-diners-club': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M239.7 79.9c97.2 0 175.8 78.6 175.8 175.8 0 96.9-78.6 175.8-175.8 175.8-96.9 0-175.8-78.9-175.8-175.8 0-97.2 78.9-175.8 175.8-175.8zM199.8 359.5v-207.9c-41.7 16.2-71.4 56.7-71.4 104.1 0 47.4 29.7 87.9 71.4 103.8zM279.6 359.8c41.7-16.2 71.4-56.7 71.4-104.1 0-47.4-29.7-87.9-71.4-104.1v208.2zM528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480zM329.7 448c105 0 200.7-85.5 200.7-190.2 0-114.6-95.7-193.8-200.7-193.8h-90.3c-106.2 0-193.8 79.2-193.8 193.8 0 104.7 87.6 190.2 193.8 190.2h90.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-diners-club.js
// module id = 743
// module chunks = 0